export default __webpack_public_path__ + "static/media/gallery-wip-crystal-holder_11.167cfc49.jpg";